import React, { useEffect } from "react";
import elevateEnergy from "../../../main/assets/images/Images/Manufacturing/elevateEnergy.png";
import servicebanner from "../../../main/assets/images/Images/Manufacturing/service_banner.png";
import serviceimg4 from "../../../main/assets/images/Images/Manufacturing/service_img_4.png";
import manufacturBanner from "../../../main/assets/images/Images/Manufacturing/manufactur-bg.png";
import service_img1 from "../../../main/assets/images/Images/Manufacturing/service_img1.png";
import service_img2 from "../../../main/assets/images/Images/Manufacturing/service_img2.png";
import professionalServices from "../../../main/assets/images/Images/Manufacturing/professional-services.png";
import endToEndVisibility from "../../../main/assets/images/Icons/Manufacturing/tools.svg";
import mlBasedDecision from "../../../main/assets/images/Icons/Manufacturing/ml-based.svg";
import operationalPlanning from "../../../main/assets/images/Icons/Manufacturing/tools.svg";
import realTime from "../../../main/assets/images/Icons/Manufacturing/realtime.svg";
import routePlanning from "../../../main/assets/images/Icons/Manufacturing/routeplanning.svg";
import scenarioModelling from "../../../main/assets/images/Icons/Manufacturing/senario.svg";
import Group1 from "../../../main/assets/images/Icons/Manufacturing/group1.png";
import Group2 from "../../../main/assets/images/Icons/Manufacturing/group2.png";
import Group3 from "../../../main/assets/images/Icons/Manufacturing/group3.png";
import Group4 from "../../../main/assets/images/Icons/Manufacturing/group4.png";
import Group6 from "../../../main/assets/images/Icons/Manufacturing/group6.png";
import { Button } from "main/components/ui-components/Button";
import { MainPageHeader, SectionCard } from "main/components";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import SectioncardserviceIndustry from "main/components/componentsHelper/whtyantrapage/SectioncardserviceIndustry";

const featuresTailored = [
  {
    image: realTime,
    whiteIcon: Group1,
    title: "Demand Forecasting",
    subTitle:
      "Predictive algorithms that analyze historical and current data to project future service demands.",
  },
  {
    image: operationalPlanning,
    whiteIcon: Group2,
    title: "Operational Planning Tools",
    subTitle:
      " Assisting in immediate decision-making by providing a real-time overview of your operational metrics with automated workflows.",
  },
  {
    image: routePlanning,
    whiteIcon: Group3,
    title: "Final Mile Operations Optimization",
    subTitle:
      "Optimize the routes for service personnel, reducing travel time and increasing the number of service calls they can attend to in a day.",
  },
  {
    image: scenarioModelling,
    whiteIcon: Group4,
    title: "Scenario Modelling",
    subTitle:
      "Test potential business strategies or decisions in a risk-free environment to anticipate their outcomes.",
  },
  {
    image: endToEndVisibility,
    whiteIcon: Group2,
    title: "End-to-End Visibility",
    subTitle:
      "A comprehensive view of the service lifecycle, from request to fulfillment, helping identify potential bottlenecks.",
  },
  {
    image: mlBasedDecision,
    whiteIcon: Group6,
    title: "Supplier Management",
    subTitle:
      "Establish two way communications with vendor risk management for a more robust supply chain.",
  },
];

const realWorldUseCases = [
  {
    image: professionalServices,
    title: "Supplier Risk Management",
    subTitle:
      "Track supplier performance with interact with your vendors for a amplified synergy, improving supplier chain robustness.",
  },
  {
    image: service_img2,
    title: "Route Optimization",
    subTitle:
      "Leverage route planning with real world data points to optimize your fleet operations tackling delays and carbon footprint.",
  },
  {
    image: service_img1,
    title: "Demand Forecasting",
    subTitle:
      "Analyse historical trends with market conditions to predict precise demand forecasts for maintaining optimum stocks.",
  },
];

export default function ServicesIndustry() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section>
        <MainPageHeader
          backgroundImage={manufacturBanner}
          mobilebgImage={servicebanner}
          HeaderClassName="text-color-success"
          heading={"Retail Industry"}
          descriptionClass="text-color-success mb-3"
          description="In the fast-paced world of retail, staying ahead requires more than just meeting customer expectations—it demands innovation, agility, and precision in every step of the supply chain."
          subDescription="Yantr.ai offers cutting-edge AI solutions designed to empower retail businesses to streamline operations, optimize supply chains, manage suppliers, and deliver exceptional customer experiences."
          buttonGroup={
            <>
              <div className="d-block d-md-none">
                <Link to={"/contact-us"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                    className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="Book a Demo"
                  />
                </Link>
              </div>
              <div className="d-none d-md-block">
                <Link to={"/contact-us"}>
                  <Button
                    textclass="font-16 fonts-500 align-items-center text-center line-19 p-17 font-family-roboto-flex justify-content-center"
                    className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                    text="Book a Demo"
                  />
                </Link>
              </div>
            </>
          }
        />
      </section>
      <div className="container-fluid d-block d-md-none">
        {/* mobile */}
        <section className=" container-fluid py-60 d-flex flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 mb-25 px-10 line-35 font-family-roboto text-align-center para-heading">
            Features Tailored for the Retail Industry
          </p>
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper customSwiper"
          >
            {featuresTailored.map((val, index) => (
              <SwiperSlide className="p-10">
                <div className="col-md-12 col-sm-12 col-lg-12 p-10">
                  <Col key={index}>
                    <SectioncardserviceIndustry
                      classname="cards"
                      title={val.title}
                      icon={val.image}
                      whiteIcon={val.whiteIcon}
                      desc={val.subTitle}
                    />
                  </Col>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      </div>
      <div className="container d-none d-md-block">
        {" "}
        {/* website */}
        <section className=" container py-60 d-flex flex-column align-items-center">
          <p className="dark-header fonts-800 font-30 mb-25 line-35 font-family-roboto text-align-center para-heading">
            Features Tailored for the Retail Industry
          </p>

          <div className="row justify-content-center cardsection px-mob-140">
            {featuresTailored.map((item: any, index: any) => {
              return (
                <div className="d-flex justify-content-center col-md-6 col-sm-12 col-lg-3 mx-2 py-10">
                  <div className="row gap-5" key={index}>
                    <div
                      className={`tcard-container d-flex flex-column py-20 radius-10 justify-content-center border border-1`}
                    >
                      <div className="image-container">
                        <img
                          className="tfront-image mx-5 my-3 mt-5"
                          src={item?.image}
                          alt="background will be here"
                        />
                        <img
                          className="tback-image mx-5 my-3"
                          src={item?.whiteIcon}
                          alt="background will be here"
                        />
                      </div>
                      <div className="card-body">
                        <p
                          className={`d-flex justify-content-center text-center card-title px-5 fonts-600 font-family-roboto font-24 line-26 pb-2`}
                          style={{ color: "#3D1187" }}
                        >
                          {item?.title}
                        </p>
                        <p
                          className="px-3 tcard-desc text-center text-white-color fonts-400 font-18 line-20 font-family-roboto"
                          style={{ color: "#3D1187" }}
                        >
                          {item?.subTitle}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>

      <section className="py-60 font-family-roboto footer d-flex flex-column align-items-center">
        <p className="text-white-color fonts-800 font-30 mb-50 text-align-center line-35 font-family-roboto realworld">
          Real World Use Cases
        </p>

        <div className="row w-85 flex-gap-20 justify-content-between">
          {realWorldUseCases.map((item: any, index: any) => {
            return (
              <div
                key={index}
                className="real-world-view card-container1 flex-column w-30 mobile-cards-width d-flex px-16"
              >
                <img
                  src={item?.image}
                  className="img-br-8 "
                  alt="background will be here"
                />
                <p className="text-white-color font-family-roboto fonts-800 font-20 line-24 mt-3">
                  {item?.title}
                </p>
                <p className="text-white-color font-family-roboto fonts-400 font-16 line-20 mt-3  footer-subcontent2">
                  {item?.subTitle}
                </p>

                <div className="d-flex align-items-end h-100 mt-20 mb-10">
                  <Link to={"/contact-us"}>
                    <div className="d-none d-md-block">
                      {/* website */}
                      <Button
                        className="py-8 px-4 font-14 line-20 font-family-roboto fonts-500 text-white-color button-purple radius-10"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </div>
                    <div className="d-block d-md-none pt-30">
                      <Button
                        className="py-8 px-4 font-14 line-20 font-family-roboto fonts-500 text-white-color button-purple radius-6"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <div className="mx-20 pt-60">
        <div className="radius-20 footer d-block  d-md-none">
          {/* mobile */}
          <section
            className="mb-40 py-4 py-md-0 radius-20"
            style={{
              backgroundImage: `url(${serviceimg4})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              //height:"200px",
            }}
          >
            <div className="row py-0 py-md-5">
              <div className="col-lg-6 col-md-12"></div>
              <div className="col-lg-6 col-md-12 px-5 pt-400">
                <p className="text-white-color fonts-800 font-20 line-23 mb-10 pt-20 font-family-condensed">
                  Transforming Supply Chains with Yantr.ai
                </p>
                <p className="text-white-color fonts-400 font-13 font-family-condensed line-15 mb-30 ">
                  AI solution that optimizes supply chains through deep
                  analytical insights, decision-making support, and future-proof
                  technologies.
                </p>
                <div className="pb-40">
                  <Link to={"/contact-us"}>
                    <Button
                      textclass="font-16 fonts-500 align-items-center text-center line-19 font-family-roboto-flex justify-content-center"
                      className="wx-90 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justify-content-center"
                      text="Contact Us"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className="container d-none d-md-block">
          {/* Website */}
          <section
            className="mb-60 py-3 py-md-0 radius-20"
            style={{
              backgroundImage: `url(${elevateEnergy})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "350px",
            }}
          >
            <div className="row py-0 py-md-5">
              <div className="col-lg-6 col-md-12"></div>
              <div className="col-lg-6 col-md-12 px-5 p-20">
                <p className="text-white-color fonts-700 font-32 line-37 mb-10 pt-0 font-family-condensed mobile-contactus-heading">
                  Transforming Supply Chains with Yantr.ai
                </p>
                <p className="text-white-color fonts-400 font-20 font-family-condensed line-23 mb-10 mobile-contactus-subheading">
                  AI solution that optimizes supply chains through deep
                  analytical insights, decision-making support, and future-proof
                  technologies.
                </p>
                {/* <p className="text-white-color fonts-400 font-20 font-family-condensed line-23 mb-20 mobile-contactus-subheading">
                  Experience the Yantr.ai advantage today.
                </p> */}
                <Link to={"/contact-us"}>
                  <Button
                    className="py-12 px-4 font-16 fonts-500 text-white-color font-family-roboto-flex"
                    onClick={() => {}}
                  >
                    Contact Us
                  </Button>
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
